import { useQuery, UseQueryResult } from "@tanstack/react-query";
import type { ResponseGetCdtCategoryTree } from "@CommonApi/cdt/categories/_categoryId_/tree";
import { fetchCdtCategoryTree } from "./cdtTreeService";

export const CDT_CATEGORY_TREE_QUERY_KEY = (
  categoryId?: number,
): readonly ["cdt-category-tree"] | readonly ["cdt-category-tree", number] =>
  categoryId === undefined ? ["cdt-category-tree"] : ["cdt-category-tree", categoryId];

export const CDT_TREE_QUERY_KEY = (
  treeId?: number,
): readonly ["cdt-tree"] | readonly ["cdt-tree", number] =>
  treeId === undefined ? ["cdt-tree"] : ["cdt-tree", treeId];

export const useCdtCategoryTreeQuery = (
  categoryId?: number,
  enabled = true,
): UseQueryResult<ResponseGetCdtCategoryTree> =>
  useQuery({
    queryKey: CDT_CATEGORY_TREE_QUERY_KEY(categoryId),
    queryFn: () => {
      if (categoryId === undefined) throw new Error("CategoryId is required");
      return fetchCdtCategoryTree(categoryId);
    },
    enabled: Boolean(enabled && categoryId !== undefined && categoryId > 0),
    staleTime: Infinity,
  });
